

import React from 'react';
import Loading from "../../common/Loading/Loading";
import { useQuery, gql } from '@apollo/client';

const LEADS_CALLBACKS_QUERY = gql`query leads_callbacks{
  leads_callbacks{
    id,
    remonline_data,
    remonline_id,
    act_number,
    device_type_id,
    problem_type_id,
    status_id,
    model,
    comment,
    created_at
    client {
      id,
      name,
      phone
    }
  }
}`

export const LeadsCallbacksCount = () => {
  const { data, loading } = useQuery(LEADS_CALLBACKS_QUERY, {
    pollInterval: 20000,
  });

  if (loading) {
    return <span></span>
  }

  return <span>
    Лист обзвона: {data.leads_callbacks.length}
  </span>

}

